module.exports = __webpack_public_path__ + "img/icon.a386c36b.png";